module.exports = __webpack_public_path__ + "img/11.68a86e6d.webp";